import { css } from 'lit'

export const vesselOwnRouteReasonPopupStyles = [
    css`
        :host {
            display: block;
        }
        
        .progress-bar-container {
            width: 300px;
            padding-left: 5px;
        }
        .green-bold {         
            color: green;
            font-weight: bold;
        }

        .default{
            background: #EDEDED;
        }

        .lowdeviation{
            background-color: #FFF1C2;
            font-weight: bold;
        }

        .label {
            border-radius: 100px;
            width: 10rem;
            padding: 0.1rem 0rem;
            display: flex;
            gap: 0.2rem;
            margin-left: -8px;
            align-items: center;
            color: black;
        }

        .label svg{
            width: 16px;
            height: 16px;
            display: flex;
        }

        .container {
            position: relative;
            display: grid;
            grid-template-columns: 170px 170px;
            border: 4px solid var(--neutrals-grey-06, grey);
            font-family: MaerskText;
            margin: 10px;
            align-items: center;
            border-radius: 8px;
        }
        .deviation {
            background-color: #fcdde0;
            font-weight: bold;
        }

        .aligned {
            background-color: #dcf6d9;
            font-weight: bold;
        }

        .default {
            background: #ededed;
        }

        .lowdeviation {
            background-color: #fff1c2;
            font-weight: bold;
        }

        .container {
            position: relative;
            display: grid;
            grid-template-columns: 170px 170px;
            border: 4px solid var(--neutrals-grey-06, grey);
            font-family: MaerskText;
            margin: 10px;
            align-items: center;
            border-radius: 8px;
        }

        .time-schedules {
            font-size: 11px;
        }

.container>.starRoute[avaliable] {
    margin: 0px;
    grid-column: span 2;
    height: 24px;
    position: relative;
    background-color: #D3ECF9;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    padding: 0px 4px;
}

.route-selection-status {
    grid-column: span 2;
    display: flex;
    justify-content: center;
    margin-top: 12px;
    padding: 4px 8px;
}

.route-selection-status__text {
    width: fit-content;
    box-sizing: border-box;
    padding: 8px 12px;
    border-radius: 100px;
    background-color: #dcf6d9;
    color: #000;
    font-family: MaerskText;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.4;
    text-align: center;
}

.route-selection-status__text.deviation {
    background-color: #fcdde0;
}

        .editBtnWrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            background: none;
        }
        
        .aligned {
            background-color: #dcf6d9;
            font-weight: bold;
        }

        .default {
            background: #ededed;
        }

        .lowdeviation {
            background-color: #fff1c2;
            font-weight: bold;
        }
        .time-schedules {
            font-size: 11px;
        }

        .editBtnWrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            background: none;
        }

        .container {
            position: relative;
            display: grid;
            grid-template-columns: 170px 170px;
            border: 4px solid var(--neutrals-grey-06, grey);
            font-family: MaerskText;
            margin: 10px;
            align-items: center;
            border-radius: 8px;
        }

.selected-route {
   max-width: 100%;
   display: flex;
   white-space: pre;
}

.selected-route--name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.port {
    position: relative;
    color: black;
    font-size: 14px;
    font-weight: bold;
}
        .progress-tooltip {
            width: 100%;
        }

        .progress-text {
            font-size: 12px;
        }

        .progress-tooltip-text {
            font-size: 14px;
            font-family: MaerskText;
        }

        .padding-right {
            padding-right: 7px;
        }

        .padding-left {
            padding-left: 7px;
        }
        .time-schedules {
            font-size: 11px;
        }

        .editBtnWrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
        }

        .progress-header {
            font-size: 14px;
            font-weight: bold;
            padding-bottom: 15px;
            padding-top: 15px;
        }

        .container {
            position: relative;
            display: grid;
            grid-template-columns: 170px 170px;
            border: 4px solid var(--neutrals-grey-06, grey);
            font-family: MaerskText;
            margin: 10px;
            align-items: center;
            border-radius: 8px;
        }

        .recalculating {
            margin-top: 16px;
            text-align: center;
            grid-column: span 2;
        }

        .container > .starRoute {
            margin: 0px;
            grid-column: span 2;
            height: 24px;
            position: relative;
            background-color: #ededed;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            border-radius: 2px 2px 0px 0px;
        }

        .container > .starRoute[avaliable] {
            margin: 0px;
            grid-column: span 2;
            height: 24px;
            position: relative;
            background-color: #d3ecf9;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            padding: 0px 4px;
        }

        .container > voyage-vessel-details-menu {
            margin: 16px;
            grid-column: span 2;
            height: 24px;
            position: relative;
        }

        .container > * {
            margin-left: 16px;
            margin-right: 16px;
        }

        .selected-route {
            max-width: 100%;
            display: flex;
            white-space: pre;
        }

        .selected-route--name {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }

        .time-schedules {
            font-size: 11px;
        }

        .editBtnWrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
        }

        .container[planning] {
            border: 4px solid var(--warning-yellow-7, yellow);
        }

        .container[approved] {
            border: 4px solid var(--approved-plan-color, green);
        }

        .port {
            position: relative;
            color: black;
            font-size: 14px;
            font-weight: bold;
        }

        .voyage-number {
            font-size: 11px;
            color: var(--neutrals-grey-02, black);
            grid-column: span 2;
            margin: 2px 16px 12px 16px;
            padding: 0;
        }

        .bottomMargin {
            margin-bottom: 16px;
        }

        .timeHeader {
            font-size: 12px;
            color: var(--neutrals-grey-02, black);
        }

        .time {
            font-size: 12px;
            color: var(--neutrals-grey-04, grey);
        }

        .editBtnWrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
        }

        voyage-spinner.planStatus {
            background-color: var(--neutrals-grey-10, white);
            --voyage-spinner-bg-color: var(--neutrals-grey-08, grey);
            --voyage-spinner-stroke-width: 2px;
        }
        .drafts-titles,
        .drafts-values {
            position: relative;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }

        .drafts-titles-imminent {
            position: relative;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }

        .pilot-titles,
        .pilot-values {
            position: relative;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }

        .planStatus {
            position: absolute;
            margin: 0;
            top: -7px;
            right: -7px;
            height: 15px;
            width: 15px;
            border-radius: 50%;
            background-color: var(--neutrals-grey-07, grey);
        }

        .planStatus[planning] {
            background-color: var(--warning-yellow-7, yellow);
        }

        .planStatus[approved] {
            background-color: var(--approved-plan-color, green);
        }

        button {
            box-sizing: border-box;
            margin: 0;
            border: none;
            outline: none;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 20px;
            padding: 0;
            color: var(--primary-blue-04, blue);
            background-color: var(--primary-blue-10, lightblue);
            fill: currentColor;
            font-family: MaerskText;
            font-size: 12px;
        }

        button[hidden] {
            display: none;
        }

        #optionsButton {
            position: absolute;
            margin: 0;
            display: none;
            color: var(--neutrals-grey-02, black);
            background: none;
            top: 10px;
            right: 10px;
            width: 18px;
            height: 18px;
        }

        #optionsButton > svg {
            width: 100%;
            height: 100%;
        }

        .omittedPortName {
            color: var(--neutrals-grey-04, grey);
            font-size: 12px;
            text-transform: uppercase;
            font-weight: bold;
            text-decoration-line: line-through;
        }

        .portNotification {
            border-radius: 10px;
            padding: 2px 5px;
            font-size: 9px;
            line-height: 12px;
            justify-self: left;
        }

        .omitColor {
            color: #370005;
            background-color: #fcdde0;
        }

        .inducementColor {
            color: var(--primary-blue-05);
            background-color: rgba(var(--primary-blue-05-rgb), 0.07);
        }

        .changeColor {
            color: var(--neutrals-grey-04);
            background-color: rgba(var(--neutrals-grey-04-rgb), 0.07);
        }

        .strikethrough {
            text-decoration-line: line-through;
        }

        .timeAndEditWrapper {
            position: relative;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-column: span 2;
            column-gap: 20px;
        }

        .editButton {
            border: none;
            outline: none;
            font-size: 12px;
            color: var(--primary-blue-04, blue);
            background-color: transparent;
            margin-left: auto;
            width: auto;
        }

        .drafts-container {
            grid-column: span 2;
            padding-top: 16px;
            font-size: 12px;
            color: var(--neutrals-grey-02, black);
            border-top: 1px solid var(--neutrals-grey-06);
            margin: 0px 16px 12px;
        }

        .pilot-container {
            grid-column: span 2;
            margin: 0;
            font-size: 12px;
            color: var(--neutrals-grey-02, black);
            margin: 0px 16px 12px;
        }

        .drafts-values,
        .pilot-titles,
        .pilot-values {
            position: relative;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
        }

        .utcWarn {
            font-weight: bold;
            color: var(--warning-yellow-7);
        }

        .time span {
            white-space: nowrap;
        }

        .wr-status {
            font-family: MaerskText;
            font-size: 12px;
            font-weight: 400;
            border-radius: 100px;
            text-align: center;
            display: flex;
            padding: 0px 6px;
            justify-content: center;
        }
        .wr-not-required {
            background-color: #ededed;
        }
        .wr-updated {
            background-color: #dcf6d9;
        }
        .wr-status-container {
            grid-column: span 2;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 12px;
        }
        .solidGm {
            padding-right: 2rem;
        }
        .Gmt {
            padding-right: 3rem;
        }
        .editBtnWrapperGMT {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            background: none;
            width: max-content;
        }
        .time span {
            white-space: nowrap
        }
    `,
]
